import rootReducer from "../../../store";
import { setServiceProviderData } from "../../../slices/psp/serviceProvider/reducer";
import { resetFormState } from "../../../slices/common/reducer";
import { getSwitchDropdown } from "../../../Utils/CommonService";
import { setDrodownData } from "../../../slices/header/headerSlice";
import { showToast } from "../../../common/Toaster/Toaster";
import api from "../../../Utils/interface";

export const getServiceProviderList = (entity_type) => {
  api
    .post(`/entity/readAll`, null, {
      params: {
        entity_type: entity_type,
      },
    })
    .then((res) => {
      rootReducer.dispatch(setServiceProviderData(res.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const createServiceProvider = (entity_type, formData, navigator) => {
  let fd = new FormData();

  fd.append("entity", JSON.stringify(formData));
  fd.append("entitytype", entity_type);
  api
    .post(`/entity/create`, fd, {})
    .then((res) => {
      rootReducer.dispatch(resetFormState());
      const updatedDropdownData = getSwitchDropdown();
      rootReducer.dispatch(setDrodownData(updatedDropdownData));
      navigator("/psp/psp");
      showToast("PSP created successfully", "success");
    })
    .catch((err) => {
      showToast(err?.response?.data?.error_message, "error");
    });
};

export let updateServiceProviderList = async (entity, entityid, navigator) => {
  const updatedEntity = {
    ...entity,
    entityid: entityid,
    entitytype: "PSP",
  };

  let fd = new FormData();
  fd.append("entityid", entityid);
  fd.append("entitytype", updatedEntity.entitytype);
  fd.append("entity", JSON.stringify(updatedEntity));

  api
    .post(`/entity/update`, fd, {})
    .then((res) => {
      console.log(res.data);
      rootReducer.dispatch(resetFormState());
      const updatedDropdownData = getSwitchDropdown();
      rootReducer.dispatch(setDrodownData(updatedDropdownData));
      navigator("/psp/psp");
      showToast("PSP updated successfully", "success");
    })
    .catch((err) => {
      showToast(err?.response?.data?.error_message, "error");
    });
};
